import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import './ShopPage.css'; // Just creating the structure, css can be added later

const ShopPage: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleMockUpgrade = async (tier: string) => {
    setLoading(true);
    try {
      if (tier === 'free') {
        await api.post('/billing/mock-cancel');
      } else {
        await api.post('/billing/mock-upgrade', { tier });
      }
      alert(`Erfolgreich auf ${tier} aktualisiert! (Mock)`);
      // Optional: Refresh user context to update UI immediately
      window.location.reload();
    } catch (error) {
      console.error('Upgrade failed', error);
      alert('Upgrade fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  const currentTier = user?.planTier || 'free';

  return (
    <div className="shop-page">
      <h1>Abonnements</h1>
      <p>Wähle den passenden Plan für deine Immobilien.</p>

      <div className="pricing-grid">
        {/* FREE */}
        <div
          className={`pricing-card ${currentTier === 'free' ? 'active' : ''}`}
        >
          <h2>Free</h2>
          <div className="pricing-price">
            0,00 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>1 Immobilie</li>
            <li>1 Bewertung</li>
            <li>50 MB Speicherplatz</li>
            <li>6 Monate Marktdaten-Historie</li>
          </ul>
          <button
            disabled={loading || currentTier === 'free'}
            onClick={() => handleMockUpgrade('free')}
          >
            {currentTier === 'free'
              ? 'Dein aktueller Plan'
              : 'Downgrade auf Free'}
          </button>
        </div>

        {/* LIGHT */}
        <div
          className={`pricing-card ${currentTier === 'light' ? 'active' : ''}`}
        >
          <h2>Light</h2>
          <div className="pricing-price">
            4,99 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>Bis zu 3 Immobilien</li>
            <li>Unbegrenzte Bewertungen</li>
            <li>1 GB Speicherplatz</li>
            <li>1 Jahr Marktdaten-Historie</li>
          </ul>
          <button
            disabled={loading || currentTier === 'light'}
            onClick={() => handleMockUpgrade('light')}
          >
            {currentTier === 'light'
              ? 'Dein aktueller Plan'
              : 'Upgrade auf Light'}
          </button>
        </div>

        {/* PRO */}
        <div
          className={`pricing-card ${currentTier === 'pro' ? 'active' : ''}`}
        >
          <h2>Pro</h2>
          <div className="pricing-price">
            12,99 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>Bis zu 10 Immobilien</li>
            <li>Unbegrenzte Bewertungen</li>
            <li>5 GB Speicherplatz</li>
            <li>5 Jahre Marktdaten-Historie</li>
          </ul>
          <button
            disabled={loading || currentTier === 'pro'}
            onClick={() => handleMockUpgrade('pro')}
          >
            {currentTier === 'pro' ? 'Dein aktueller Plan' : 'Upgrade auf Pro'}
          </button>
        </div>

        {/* BUSINESS */}
        <div
          className={`pricing-card ${currentTier === 'business' ? 'active' : ''}`}
        >
          <h2>Business</h2>
          <div className="pricing-price">
            49,99 € <span>/ Monat</span>
          </div>
          <ul className="pricing-features">
            <li>Unbegrenzte Immobilien</li>
            <li>Unbegrenzte Bewertungen</li>
            <li>20 GB Speicherplatz</li>
            <li>10 Jahre Marktdaten-Historie</li>
          </ul>
          <button
            disabled={loading || currentTier === 'business'}
            onClick={() => handleMockUpgrade('business')}
          >
            {currentTier === 'business'
              ? 'Dein aktueller Plan'
              : 'Upgrade auf Business'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShopPage;
